<!-- Layout de Free NAS: solo header superior, sin sidebar -->
<div class="free-nas-wrapper" *ngIf="storageService.view_modules">
  <app-free-nas-header></app-free-nas-header>

  <!-- html y body tienen overflow hidden de forma global, asi que el scroll
       de las secciones vive en este contenedor -->
  <div class="free-nas-scroll">
    <main class="main-container">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
